function debounce(fn, delay) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn(...args), delay);
  };
}
function extractWidgetId(url) {
  if (typeof url !== 'string') return null;
  const match = url.match(/\/files\/([^_]+?-\d+)(?:_|\.|\?|$)/);
  return match ? match[1] : null;
}

const handleSrcChange = debounce((img) => {
  const containers = document.querySelectorAll('.vw-parent');
  if (containers.length > 0) {
    containers.forEach(container => container.classList.remove('vw-parent'));
    
  } 

  const widgets = document.querySelectorAll('.vw-product-widget');
  if (widgets.length > 0) {
    widgets.forEach(widget => widget.remove());
  }

  const btns = document.querySelectorAll('#cloneVwBtn');
  if (btns.length > 0) btns.forEach(btn => btn.remove());

  const thumbVw = document.querySelector('.thumb');
  const imgvw = thumbVw?.querySelector('img');

  if (thumbVw && imgvw) {
    const prevImg = thumbVw.previousElementSibling;
    imgvw.alt = '';
    if (!prevImg || prevImg.tagName !== 'IMG') {
      const imgClone = imgvw.cloneNode(true);
      thumbVw.parentNode.insertBefore(imgClone, thumbVw);
    } 
  }

   const swatch = document.querySelector('.js-swatch_wrapper.current');
    if (swatch) {
      const images = swatch.dataset.imagesThumb?.split(';') || [];

      document.querySelectorAll('.js-desktop-images-wrapper img:not(.zoomImg)').forEach((imgEl, index) => {
        const imageSrc = images[index];
        if (imageSrc && imageSrc.includes('reeview')) {
            const widgetId = extractWidgetId(imageSrc);
            if (widgetId) {
              imgEl.alt = widgetId || '';
              const lastSegment = widgetId.split('-').pop();
              if (typeof window.__st !== 'undefined' && typeof window.__st.rid !== 'undefined') {
                window.__st.rid = lastSegment;
              }
            }
        } 
      });
    }

  if (typeof videowiseBulkTrigger === 'function' && typeof initVideowise === 'function') {
    try {
      setTimeout(() => {
        videowiseBulkTrigger();
        initVideowise();
      }, 120);
    } catch (err) {
      console.error('❌ Error calling Videowise functions:', err);
    }
  }
}, 180);

document.addEventListener('click', (e) => {
  const swatch = e.target.closest('.js-swatch_wrapper');
  if (!swatch) return;
  const img = document.querySelector('.js-desktop-image-item');
  if (!img) {
    return;
  }

  setTimeout(() => {
    handleSrcChange(img);
  }, 120);
});

// Initialize Videowise on page load for the currently selected swatch
function initializeVideowiseOnLoad() {
  let retryCount = 0;
  const maxRetries = 15; // Maximum 3 seconds of retries (15 * 200ms)
  
  // Wait for DOM to be ready and check if Videowise functions are available
  const checkAndInit = () => {
    const currentSwatch = document.querySelector('.js-swatch_wrapper.current');
    const img = document.querySelector('.js-desktop-image-item');
    
    if (currentSwatch && img) {
      // Check if Videowise functions are available, if not wait a bit more
      if (typeof videowiseBulkTrigger === 'function' && typeof initVideowise === 'function') {
        handleSrcChange(img);
      } else if (retryCount < maxRetries) {
        // Retry after a short delay if functions aren't loaded yet
        retryCount++;
        setTimeout(checkAndInit, 120);
      }
    } else if (retryCount < maxRetries) {
      // Elements not ready yet, retry
      retryCount++;
      setTimeout(checkAndInit, 120);
    }
  };

  // Try multiple times to ensure everything is loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(checkAndInit, 280);
    });
  } else {
    // DOM is already ready
    setTimeout(checkAndInit, 280);
  }

  // Also try on window load as a fallback (reset retry count)
  window.addEventListener('load', () => {
    retryCount = 0;
    setTimeout(checkAndInit, 150);
  });
}

// Start initialization
initializeVideowiseOnLoad();

